<template>
  <div :class="[mlw?'mwf':'mwa', 'menu_wrapper']">
    <Menu :imgbool="[mlw?1:0]" :isproject="ipj"></Menu>
  </div>
</template>

<script>
  import Menu from "./Menu.vue";
  export default {
    name: "HeaderTop",
    data: function() {
      return {
        mlw: false,
        ipj: true
      }
    },
    components: { Menu },
    mounted:function(){
      window.addEventListener('scroll', this.handleScroll, true);
    },
    methods: {
      // 保存滚动值，这是兼容的写法
      handleScroll: function(e) {
        var headerHeight = (document.querySelector("#header").offsetHeight) * 0.96463;
        var dom = e.target;
        this.scrollTop = dom.pageYOffset || dom.scrollTop;
        this.mlw = (this.scrollTop > ((headerHeight > 0)?headerHeight:414.128))?true:false;
        this.ipj = !(this.mlw);
      }
    }
  }
</script>

<style type="text/less" lang="less" scoped="scoped">
  .header_content {
    width: 100%;
    position: relative;
    z-index: 1;
    @import url("../../assets/css/menu.less");
    .mwa {
      position: fixed;
      top: 2.031vw;
      bottom: auto;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/HeaderTop.vue